import * as actions from '../../actions/actionTypes';

const initialState = { list: [], isDataLoad: false };

export default function rsChannelIds(state = initialState, action) {
  switch (action.type) {
    case 'GET_RS_CHANNEL_IDS':
      return action.payload;
    default:
      return state;
  }
}
